import React from "react";
import { Route } from "react-router-dom";
import { Switch, Redirect } from "react-router-dom";
import Footer from "../components/footer";
import Login from "../pages/login";
import Role from "../pages/role";
import SetPassword from "../pages/set_password";
import ResetPassword from "../pages/reset_password";

const AuthLayout = () => {
  return (
    <div className="d-flex flex-column h_100">
      <Switch>
        <Route path="/user/login" component={Login} />
        <Route path="/user/setpassword" component={SetPassword} />
        <Route path="/user/resetpassword" component={ResetPassword} />
        <Redirect from="/user" to={"/user/login"} />
      </Switch>
      <Footer />
    </div>
  );
};

export default AuthLayout;
